module.exports = __webpack_public_path__ + "img/Event_YD.7ffe8cf3.webp";